module.exports = __webpack_public_path__ + "img/image-dummy.f0158a6c.svg";